import React from "react";
import generatePassword from "generate-password";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import "./index.css";
import AddUmbrellaAdminModal from "../../components/AddUmbrellaAdminModal";
import {
  sendUmbrellaPasswordEmail,
  removeTaskerFromAuth,
  resetPassword,
} from "../../api/UserApi";
import ResetPasswordSuperAdminModal from "../../components/ResetPasswordSuperAdminModal";

const user_icon = require("../../assets/media/user.png");
const remove_icon = require("../../assets/media/stop.png");

class UmbrellaAdmins extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      subAdmins: [],
      brands: [],
      brand_name: "",
    };
  }

  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand });

      Firebase.getAllAgencies((res) => {
        this.setState({ subAdmins: res.filter((obj) => obj.role === 10) });
      });
      Firebase.getAllBrands((res) => {
        this.setState({ brands: res });
      });
    }
  }

  addSubAdmin = (name, email, brand) => {
    const password = generatePassword.generate({
      length: 10,
      numbers: true,
    });
    Firebase.addAgency(email, password)
      .then((uid) => {
        Firebase.writeAgencydata(uid, {
          uid: uid,
          username: name,
          email,
          role: 10,
          brand: brand,
          approved: true,
        });
        const brandName = this.state.brands[brand].name;
        sendUmbrellaPasswordEmail(email, name, brandName, password);
      })
      .catch((err) => {
        alert(err);
      });
  };

  editUmbrellaAdmin = (item) => () => {
    this.setState({
      selectedUser: item,
    });
  };

  onResetPassword = (password) => {
    const { selectedUser } = this.state;
    if (selectedUser) {
      resetPassword(selectedUser.uid, password).catch(() => {
        console.log("Something went wrong!");
      });
    }
  };

  removeUmbrellaAdmin = (item) => () => {
    const { uid } = item;
    Firebase.removeAgency(uid);
    removeTaskerFromAuth(uid);
  };

  render() {
    const {
      username,
      role,
      logo,
      brand,
      brand_name,
      subAdmins,
      brands,
      selectedUser,
    } = this.state;
    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          logo={logo}
          brand={brand}
          brandName={brand_name}
        />
        <main id="main-container">
          <div className="home-content">
            <div className="user-content">
              <div>
                <div className="member-row">
                  <button
                    type="button"
                    className="btn add-user"
                    data-toggle="modal"
                    data-target="#addsubadmin_user"
                  >
                    Add Umbrella Admin
                  </button>
                </div>
                <div className="member-row">
                  <p className="avatar-header">Profile</p>
                  <p className="member-name">Name</p>
                  <p className="member-name">Email</p>
                  <p className="member-name">Brand</p>
                  <p className="member-name">UID</p>
                  <p></p>
                </div>
                {subAdmins.map((item) => {
                  return (
                    <div className="member-row">
                      <img
                        className="avatar-header"
                        src={user_icon}
                        width="50"
                        alt="icon"
                      />
                      <p className="member-name">{item.username}</p>
                      <p className="member-name">{item.email}</p>
                      <p className="member-name">
                        {brands[item.brand] && brands[item.brand].name}
                      </p>
                      <p className="member-name">{item.uid}</p>
                      <p>
                        <img
                          src={remove_icon}
                          className="remove-icon"
                          alt="remove"
                          onClick={this.removeUmbrellaAdmin(item)}
                        />
                        <button
                          type="button"
                          class="btn"
                          data-toggle="modal"
                          data-target="#reset_password_super_admin"
                          onClick={this.editUmbrellaAdmin(item)}
                        >
                          Reset password
                        </button>
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </main>
        <AddUmbrellaAdminModal addUser={this.addSubAdmin} />

        <ResetPasswordSuperAdminModal
          onSave={this.onResetPassword}
          initialValues={selectedUser}
        />
      </div>
    );
  }
}
export default UmbrellaAdmins;



// WEBPACK FOOTER //
// ./src/screens/UmbrellaAdmins/index.js